import React, { ReactElement } from 'react';
import styles from './checkEmailConfirmation.module.scss';
import { PageTitleWithTracking as Title } from '@mo/page-title';
import { BackButton } from '@mo/back-button';

export interface CheckEmailConfirmationProps {
    backToPreviousScreen: () => void;
}

function CheckEmailConfirmation({ backToPreviousScreen }: CheckEmailConfirmationProps): ReactElement {
    const goBack = (e: React.MouseEvent): void => {
        e.preventDefault();
        backToPreviousScreen();
    };

    return (
        <>
            <div className={styles.formHeader}>
                <div className={styles.formHeaderContent}>
                    <BackButton onClick={goBack} text='Back' />
                    <Title gaTitle={'Forgot password - Please check your email'} text='Please check your email' />
                </div>
            </div>
            <p className={styles.helpText}>
                An email has been sent to reset your password. This should be received shortly.
            </p>
            <div>
                <h2 className={styles.didntReceiveHeader}>Didn't receive anything?</h2>
                <p className={styles.didntReceiveText}>
                    Please check your spam folder, or{' '}
                    <span
                        className={styles.enterUsernameAgain}
                        onClick={goBack}
                        data-ga='back-to-previous-screen'
                        role='link'
                        tabIndex={2}
                    >
                        enter your email again.
                    </span>
                </p>
            </div>
        </>
    );
}

export default CheckEmailConfirmation;
